"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCanvasToolbar = void 0;

var _Constants = require("../Constants");

var getCanvasToolbar = function getCanvasToolbar() {
  return [{
    controls: [{
      type: _Constants.TOOLBAR_CONTROL_TYPES.BUTTON,
      control: 'canvasbold'
    }, {
      type: _Constants.TOOLBAR_CONTROL_TYPES.BUTTON,
      control: 'canvasitalic'
    }, {
      type: _Constants.TOOLBAR_CONTROL_TYPES.BUTTON,
      control: 'canvasunderline'
    }]
  }, {
    controls: [{
      type: _Constants.TOOLBAR_CONTROL_TYPES.DIVIDER
    }]
  }, {
    controls: [{
      type: _Constants.TOOLBAR_CONTROL_TYPES.SELECT,
      control: 'canvasalignment'
    }, {
      type: _Constants.TOOLBAR_CONTROL_TYPES.BUTTON,
      control: 'canvasbullist'
    }, {
      type: _Constants.TOOLBAR_CONTROL_TYPES.BUTTON,
      control: 'canvasnumlist'
    }, {
      type: _Constants.TOOLBAR_CONTROL_TYPES.BUTTON,
      control: 'canvasremoveformat'
    }]
  }, {
    controls: [{
      type: _Constants.TOOLBAR_CONTROL_TYPES.DIVIDER
    }]
  }, {
    controls: [{
      type: _Constants.TOOLBAR_CONTROL_TYPES.BUTTON,
      control: 'canvaslink'
    }, {
      type: _Constants.TOOLBAR_CONTROL_TYPES.BUTTON,
      control: 'canvasemoji'
    }]
  }];
};

exports.getCanvasToolbar = getCanvasToolbar;